export type SpreadsheetCell = string | number | boolean | Date | null;

const isBlank = (value: unknown) => value === null || value === undefined || value === '';

const normalizeCell = (value: unknown): SpreadsheetCell => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date || ['string', 'number', 'boolean'].includes(typeof value)) {
    return value as Exclude<SpreadsheetCell, null>;
  }
  return String(value);
};

export function spreadsheetRowsToObjects(
  rows: readonly (readonly unknown[])[],
): Record<string, SpreadsheetCell>[] {
  if (rows.length === 0) return [];

  const headers = rows[0].map(value => String(value ?? '').trim());

  return rows.slice(1)
    .filter(row => row.some(value => !isBlank(value)))
    .map(row => Object.fromEntries(
      headers.flatMap((header, index) => (
        header ? [[header, normalizeCell(row[index])]] : []
      )),
    ));
}

export function objectsToSpreadsheetRows(
  objects: readonly Record<string, unknown>[],
  requestedColumns?: readonly string[],
): SpreadsheetCell[][] {
  const columns = requestedColumns?.length
    ? [...requestedColumns]
    : Object.keys(objects[0] ?? {});

  return [
    columns,
    ...objects.map(object => columns.map(column => normalizeCell(object[column]))),
  ];
}
